export enum CURRENT_STATUS {
  ABNORMAL = -1,
  UNDEFINED = 0,
  RED = 1,
  YELLOW = 2,
  GREEN = 3,
  BLACK = -2,
}
